import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const ResourcesMegaMenuContent = styled.div`
  display: grid;
  border-top: solid 1px ${palette.wheat};
  border-bottom: solid 1px ${palette.wheat};
  background-color: ${palette.white};
  grid-template-columns: minmax(700px, 5fr) 4fr;

  @media all and (max-width: ${layout.subxlg}) {
    grid-template-columns: 640px 1fr;
  }
`;
